
import Vue from 'vue'
import AOS from 'aos'
import Lightbox from '../components/Lightbox.vue'
import ScrollTop from '../components/ScrollTop.vue'
import Pagination from '../components/Pagination.vue'
import { caseTemplateRender } from '../mixins/caseTemplateRender'
// @ts-ignore
import Cases from '../db.ts'


export default Vue.extend({
    name: 'Case',
    props: { caseId: String },
    components: { Lightbox, ScrollTop, Pagination },
    mixins: [ caseTemplateRender ],
    data(){
        return { content: Cases(this.caseId).content }
    },
    mounted(){ window.addEventListener('resize', this.prepareForeword) },
    destroyed(){ window.removeEventListener('resize', this.prepareForeword) },
    methods: {
        aosEvent (e:Event) {},
        prepareForeword(){
            try {
                if(this.$refs.case_foreword){
                    let case_foreword = this.$refs.case_foreword as HTMLElement
                    let wrapperHeight = case_foreword.offsetHeight
                    case_foreword.style.marginBottom = 0 - wrapperHeight + 60 + 'px'
                }
            } catch(e) {
                console.groupCollapsed('Foreword animations not prepared')
                console.log(e)
                console.groupEnd()
            }
        },
        caseTemplateRenderCallback(){
            this.prepareForeword()
        }
    },
    watch: {
        '$route'(to, from){
            this.$nextTick(() => {
                this.template = ''
                this.content = Cases(this.caseId).content
                this.$forceUpdate();
            })
        }
    }
})

